"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var platform;
        (function (platform) {
            var consultantClients;
            (function (consultantClients) {
                class InitArgs {
                    constructor() {
                        this.columnCount = 0;
                        this.columnWidths = 0;
                        this.platformCreateConsultantClient = appn.emptyString;
                        this.platformAjaxAddExistingConsultee = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dataTable = null;
                function init(args) {
                    _initArgs = args;
                    createDataTable();
                    addEvents();
                }
                consultantClients.init = init;
                function addEvents() {
                    $('#addexisting').on('click', function () {
                        const infoParagraph = T('To add an existing Client as one of your own clients, contact the Organization first to retrieve the information required for the fields below.<br><br>Your new client will be able to locate this information in the Integration Settings of their Organization Setup.');
                        const infoParagraphElement = appn.elementBuilder.createElement('p', undefined, undefined, undefined, infoParagraph);
                        const providerIdLabel = appn.elementBuilder.createElement('label', 'col-form-label col-md-3', undefined, [['for', 'ConsulteeProviderId']], T('Company Id'));
                        const providerIdInput = appn.elementBuilder.getSimpleInputFor('form-control form-control-sm', 'ConsulteeProviderId', 'ConsulteeProviderId', appn.elementBuilder.HTMLInputType.Text);
                        const providerIdGroup = appn.elementBuilder.createElement('div', 'col-md-9');
                        providerIdGroup.appendChild(providerIdInput);
                        const providerIdFormGroup = appn.elementBuilder.createElement('div', 'form-group row');
                        providerIdFormGroup.appendChild(providerIdLabel);
                        providerIdFormGroup.appendChild(providerIdGroup);
                        const providerPtLabel = appn.elementBuilder.createElement('label', 'col-form-label col-md-3', undefined, [['for', 'ConsulteePrivateToken']], T('Private Token'));
                        const providerPtInput = appn.elementBuilder.getSimpleInputFor('form-control form-control-sm', 'ConsulteePrivateToken', 'ConsulteePrivateToken', appn.elementBuilder.HTMLInputType.Text);
                        const providerPtGroup = appn.elementBuilder.createElement('div', 'col-md-9');
                        providerPtGroup.appendChild(providerPtInput);
                        const providerPtFormGroup = appn.elementBuilder.createElement('div', 'form-group row');
                        providerPtFormGroup.appendChild(providerPtLabel);
                        providerPtFormGroup.appendChild(providerPtGroup);
                        const AddConsulteeMsg = appn.elementBuilder.createElement('div');
                        AddConsulteeMsg.appendChild(infoParagraphElement);
                        AddConsulteeMsg.appendChild(providerIdFormGroup);
                        AddConsulteeMsg.appendChild(providerPtFormGroup);
                        appn.dialog.custom({
                            modalColor: 'modal-info',
                            title: T('Add Existing'),
                            message: AddConsulteeMsg,
                            closeButton: true,
                            buttons: {
                                confirm: {
                                    label: '<span>' + T('OK') + '</span>',
                                    className: 'btn-success',
                                    callback: function (result) {
                                        if (!result)
                                            return;
                                        appn.ajax.post({
                                            url: _initArgs.platformAjaxAddExistingConsultee,
                                            data: {
                                                consulteeProviderId: $('#ConsulteeProviderId').val(),
                                                consulteePrivateToken: $('#ConsulteePrivateToken').val()
                                            },
                                            done: function (data) {
                                                const dataParsed = JSON.parse(data);
                                                if (!dataParsed.Success) {
                                                    appn.toast.notify(appn.toast.Type.error, dataParsed.Message);
                                                    return;
                                                }
                                                _dataTable.fnDraw(false);
                                                appn.toast.notify(appn.toast.Type.info, dataParsed.Message);
                                            },
                                            fail: function () {
                                                appn.toast.notify(appn.toast.Type.error, T('Failed to add consultee, please check the details and try again.'));
                                            }
                                        });
                                    }
                                }
                            }
                        });
                    });
                }
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        sAjaxSource: 'ConsultantClientsDataTable',
                        fnServerData: function (data) {
                            data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked')));
                        },
                        aoColumns: getDtColConfiguration(),
                        fnInitComplete: function () {
                            $('#addnew').click(function (event) {
                                event.preventDefault();
                                appn.location.navTo(_initArgs.platformCreateConsultantClient);
                            });
                            $('.dataTables_filter').prepend(appn.elementBuilder.buildCheckbox(appn.strings.showRetired, 'saveMeState', 'sCustom_0')).append($('.dt-action-button'));
                            appn.dataTable.addSearchPlaceholder(T('Filter results where the Clients <b>Name or Status</b> contains a keyword typed in here.'));
                            $('.dataTables_controls_start').append($('.dt-action-title'));
                            appn.saveMeState.init(function () {
                                _dataTable.fnDraw(false);
                            }, function () {
                                _dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                        },
                        fnDrawCallback: function () {
                            $('.viewUserAudit').off().on('click', function (event) {
                                event.preventDefault();
                                const auditUrl = $(this).attr('href');
                                appn.iframe.openModal({ url: auditUrl });
                            });
                        }
                    });
                }
                function getDtColConfiguration() {
                    const aoColumns = [];
                    aoColumns.push({ bSortable: true, sWidth: '25%' }, { bSortable: true, sWidth: '10%' });
                    for (let i = 2; i < _initArgs.columnCount; i++)
                        aoColumns.push({ bSortable: true, sWidth: `${_initArgs.columnWidths}%` });
                    aoColumns.push({ bSortable: true, sWidth: '15%' }, { bSortable: true, sWidth: '15%' });
                    return aoColumns;
                }
            })(consultantClients = platform.consultantClients || (platform.consultantClients = {}));
        })(platform = views.platform || (views.platform = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
